/*
 * Use bootstrap breakpoints in scripts
 *
 * https://www.lullabot.com/articles/importing-css-breakpoints-into-javascript
 */
import { getPseudoElementProperty } from './selector';

export default () => ({
  breakpoint: getPseudoElementProperty('body', ':before', 'content'),
  orientation: getPseudoElementProperty('body', ':after', 'content')
});



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/util/screen.js